import * as Action from "../default/reducer";

const findJournalId = (state, productId) =>
  state.products.find(p => p.id == productId).journalId;

const tracker = store => next => action => {
  const previousState = store.getState().default;

  let result = next(action);

  const state = store.getState().default;

  const EVENT_CATEGORY = state.filterName;
  let filter, eventAction, eventLabel, journalId;

  window.trackingEnabled = true;;
  if (window.trackingEnabled) {
    switch (action.type) {

      case Action.selectFilterChanged.type:
        const previousFilter = previousState.filters.find(f => f.key == action.payload.key);
        const previousValues = previousFilter.value || [];
        const nextValues = action.payload.values;

        let option;
        if (previousValues.length > nextValues.length) {
          eventAction = "FilterOptionUnselected";
          option = previousValues.filter(v => nextValues.indexOf(v) == -1);
        } else {
          eventAction = "FilterOptionSelected";
          option = nextValues.filter(v => previousValues.indexOf(v) == -1);
        }
        eventLabel = previousFilter.name + ": " + option;
        break;

      case Action.minInputChanged.type:
        filter = state.filters.find(f => f.key == action.payload.key);
        eventAction = "FilterMinValueEntered";
        eventLabel = filter.name + ": " + action.payload.value;
        break;

      case Action.maxInputChanged.type:
        filter = state.filters.find(f => f.key == action.payload.key);
        eventAction = "FilterMaxValueEntered";
        eventLabel = filter.name + ": " + action.payload.value;
        break;

      case Action.resetFilters.type:
        eventAction = "FiltersReset";
        break;

      case Action.viewModeChanged.type:
        eventAction = "ViewChange";
        eventLabel = state.viewMode;
        break;

      case Action.loadNextPage.type:
        eventAction = "LoadNextPage";
        eventLabel = `Visible pages: ${state.pagesVisible}`;
        break;
      
      // case Action.PRODUCT_CHECKBOX_CLICKED:
      //   const checked = action.data.checked;
      //   journalId = findJournalId(state, action.data.productId);

      //   eventAction = "ProductCheckboxClicked";
      //   if (checked) {
      //     eventLabel = `Selected journal ID: ${journalId}`;
      //   } else {
      //     eventLabel = `Unselected journal ID: ${journalId}`;
      //   }
      //   break;

      case Action.productAdded.type:
        journalId = findJournalId(state, action.payload.id);
        eventAction = "ProductAddedToBasket";
        eventLabel = journalId;
      break;

      case Action.productRemoved.type:
        journalId = findJournalId(state, action.payload.id);
        eventAction = "ProductRemovedFromBasket";
        eventLabel = journalId;
        break;
        
      case Action.downloadRequested.type:
        eventAction = "DownloadMaterials";
        eventLabel = `Products count: ${state.selectedProductIds.length}`;
        break;

      case Action.basketDownloadRequested.type:
        eventAction = "DownloadMaterialsFromBasket";
        eventLabel = `Products count: ${state.basket.products.length}`;
        break;
    }

    if (eventAction)  {
      gtag('event', eventAction, {
        'event_category': EVENT_CATEGORY,
        'event_label': eventLabel
      });
    }
  }

  return result;
};

export default tracker;